import styled from "styled-components"

export const Container = styled.div``
export const Content = styled.div`
  margin: 6vh 0;
  @media (max-width: 890px) {
    margin: 1vh 0;
  }
`
